import { render, staticRenderFns } from "./fireFightingLayout.vue?vue&type=template&id=153ae20c&scoped=true"
import script from "./fireFightingLayout.vue?vue&type=script&lang=js"
export * from "./fireFightingLayout.vue?vue&type=script&lang=js"
import style0 from "./fireFightingLayout.vue?vue&type=style&index=0&id=153ae20c&lang=sass"
import style1 from "./fireFightingLayout.vue?vue&type=style&index=1&id=153ae20c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ae20c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('153ae20c')) {
      api.createRecord('153ae20c', component.options)
    } else {
      api.reload('153ae20c', component.options)
    }
    module.hot.accept("./fireFightingLayout.vue?vue&type=template&id=153ae20c&scoped=true", function () {
      api.rerender('153ae20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/fft/fireFightingLayout.vue"
export default component.exports